export const navBarTeacher = (orgStructure, intl) => [
  {
    name: intl.formatMessage({ id: "Home" }),
    url: "/",
    icon: "home",
  },
  {
    title: true,
    name:
      localStorage.getItem("schoolName") === null
        ? intl.formatMessage({ id: "Navigation_Teacher_School" })
        : localStorage.getItem("schoolName"),
    url: "/",
  },
  {
    isProgramsAndClasses: true,
    programsAndClasses: [...orgStructure],
  },
];

export default navBarTeacher;
